import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withRouter } from 'react-router';
import Swiper from 'react-id-swiper';
import { ReactComponent as IconTable } from 'assets/images/icon-table.svg';

import OrderPreView from '../../components/OrderPreView';
import Select from '../../components/Select';
import { init } from './actions';
import { fetchOrder, setState, toggleMobileCart } from '../Home/actions';
import {
  getCurrentShift,
  getPickupTimeArrays,
  getDeliveryTimeArrays,
} from '../../helpers/getTimeSlots';
import { detectSoldOutItemsInCart } from '../../helpers/detectSoldOutItemsInCart';
import { getOfferUnlockedMessage } from '../../helpers/getOfferUnlockedMessage';
import OrderView from '../../components/OrderView';
import { selectStoreConfig } from '../Layout/selectors';
import UserLoginRegistration from '../../components/UserLoginRegistration';
import OrderReview from '../../components/OrderReview';
import OrderPayment from '../../components/OrderPayment';
import HalfHalfView from '../../components/HalfHalfView';
import HalfOrderView from '../../components/HalfOrderView';
import SpecialView from '../../components/SpecialView';
import SpecialOrderView from '../../components/SpecialOrderView';
import AboutDesktop from '../../components/AboutDesktop';
import LoyaltyDesktop from '../../components/LoyaltyDesktop';
import OrderPaymentCards from '../../components/OrderPaymentCards';
import TableBoookingView from '../../components/TableBookingView';
import { firebaseAnalyticsNO } from '../../firebase';
import { eventNames } from 'configuration/eventNames';
import { detectOutOfScheduleItemsInCart } from 'helpers/detectOutOfScheduleItemsInCart';

let ua = navigator.userAgent.toLowerCase();
let isAndroid = ua.indexOf('android') > -1;

const orderLabels = {
  1: `Pickup`,
  2: `Delivery`,
  3: `Dine-in`,
};

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      timeSlot: false,
      selectedTime: '',
      moveUp: false,
      moveNext: 0,
      moveNextDetail: 0,
      deliveryDateLater: '',
      isFutureDeliveryDate: false,
      shiftIdLater: '',
      showErrorInTableSelector: false,
    };

    this.params = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      observer: true,
    };

    this.params2 = {
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      observer: true,
      on: {
        slideChange: this.slideChange,
      },
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleOutSideTime.bind(this));
  }

  componentDidMount() {
    const { storeConfig } = this.props;
    this.props.initAction(storeConfig.storeId, storeConfig.restaurantId);
    window.addEventListener('click', this.handleOutSideTime.bind(this));
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  componentWillReceiveProps(props) {
    if (
      props.storeConfig &&
      props.order &&
      props.order.allShifts &&
      props.order.closeDates &&
      props.orderSetup &&
      !this.state.timesInitialized
    ) {
      let currentShift = getCurrentShift(
        props.storeConfig ? props.storeConfig : {},
        props.order.allShifts ? props.order.allShifts : [],
        props.order.closeDates ? props.order.closeDates : []
      );

      let pickUpTimes = getPickupTimeArrays(
        props.storeConfig ? props.storeConfig : {},
        props.order.allShifts ? props.order.allShifts : [],
        props.orderSetup ? props.orderSetup : {},
        props.order.closeDates ? props.order.closeDates : []
      );

      let deliveryTimes = getDeliveryTimeArrays(
        props.storeConfig ? props.storeConfig : {},
        props.order.allShifts ? props.order.allShifts : [],
        props.orderSetup ? props.orderSetup : {},
        props.order.closeDates ? props.order.closeDates : []
      );

      let timeArray = [];
      let deliveryDateLater = '';
      let isFutureDeliveryDate = false;
      let shiftIdLater = '';
      if (props.currentOrder.orderType === '1') timeArray = pickUpTimes;
      else if (props.currentOrder.orderType === '2') timeArray = deliveryTimes;
      if (timeArray.length > 0) {
        deliveryDateLater = moment(
          `${timeArray[0].times[0].timeObjFinal} ${timeArray[0].times[0].displayForUse}`,
          'YYYY-MM-DD HH:mm A'
        );
        isFutureDeliveryDate =
          timeArray[0].times[0].alternateDisplay === 'ASAP' ? false : true;
        shiftIdLater = timeArray[0].times[0].shiftId;
      }

      this.setState({
        timesInitialized: true,
        deliveryTimes,
        currentShift,
        pickUpTimes,
        deliveryDateLater,
        isFutureDeliveryDate,
        shiftIdLater,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Setup width, left and translateLeft
    if (
      ((!prevState.width &&
        !prevState.left &&
        !prevState.widthS &&
        !prevState.translateLeft) ||
        prevProps.currentOrder.orderType !==
          this.props.currentOrder.orderType ||
        prevProps.rightSideViewVisibilityIndex !==
          this.props.rightSideViewVisibilityIndex) &&
      Object.keys(this.refs)?.length > 0
    ) {
      // refs needs time to be updated
      setTimeout(() => {
        let width = 70,
          left = 0,
          widthS = 0,
          leftS = 15,
          translateLeft = 'translateX(100%)';
        if (this.props.currentOrder.orderType === '1' && this.refs['pick1']) {
          width = this.refs['pick1'].offsetWidth;
          left = this.refs['pick1'].offsetLeft;
        } else if (
          this.props.currentOrder.orderType === '2' &&
          this.refs['del1']
        ) {
          width = this.refs['del1'].offsetWidth;
          left = this.refs['del1'].offsetLeft;
        } else if (
          this.props.currentOrder.orderType === '3' &&
          this.refs['tabl1']
        ) {
          width = this.refs['tabl1'].offsetWidth;
          left = this.refs['tabl1'].offsetLeft;
        }
        if (this.refs[0 + 'LA'] !== undefined)
          widthS = this.refs[0 + 'LA'].offsetWidth;
        if (this.props.rightSideViewVisibilityIndex >= 1)
          translateLeft = 'translateX(0)';

        this.setState({
          width,
          left,
          widthS,
          leftS,
          translateLeft,
        });
      }, 0);
    }
  }

  setDeliveryTime = (e) => {
    this.setState(
      {
        timeSlot: false,
        showErrorInTimeSelector: false,
      },
      () => {
        if (this.state.deliveryDateLater && this.state.shiftIdLater) {
          this.props.updateDeliveryPickupTime(
            this.state.deliveryDateLater,
            this.state.shiftIdLater,
            false,
            0,
            this.state.isFutureDeliveryDate
          );
        }
      }
    );
    e.stopPropagation();
  };

  andMoveDown = () => {
    if (isAndroid) this.setState({ moveUp: false });
  };

  moveNextHandler = () => {
    this.setState({ moveNext: 1 });
  };

  handleChange = (timeObj) => {
    let deliveryDate = moment(
      `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
      'YYYY-MM-DD HH:mm A'
    );
    if (deliveryDate !== this.state.deliveryDateLater) {
      this.setState({
        selectedTime: timeObj.displayForUse,
        deliveryDateLater: deliveryDate,
        isFutureDeliveryDate:
          timeObj.alternateDisplay === 'ASAP' ? false : true,
        shiftIdLater: timeObj.shiftId || '',
      });
    }
  };

  checkIfTimeInFutureSelected = () => {
    if (
      this.state.currentShift &&
      this.props.orderSetup.isPreOrderingEnabled === true &&
      ((this.props.currentOrder.orderType === '2' &&
        this.state.currentShift.isDeliveryOpen === false) ||
        (this.props.currentOrder.orderType === '1' &&
          this.state.currentShift.isPickupOpen === false)) &&
      (!this.props.currentOrder.deliveryDate ||
        !this.props.currentOrder.shiftId ||
        this.props.currentOrder.shiftId.length <= 0)
    ) {
      this.setState({
        showErrorInTimeSelector: true,
      });
      return false;
    } else {
      return true;
    }
  };

  checkIfTableSelected = () => {
    if (
      this.props.currentOrder.orderType === '3' &&
      this.props.currentOrder.tableId
    ) {
      return true;
    } else {
      this.setState({
        showErrorInTableSelector: true,
      });
      return false;
    }
  };

  updateOrderStageHandler = (stage) => {
    const m = moment;
    const currentOrder = JSON.parse(JSON.stringify(this.props.currentOrder));
    firebaseAnalyticsNO.logEvent(eventNames.SELECTED_ORDER_BUTTON);
    if (
      currentOrder &&
      currentOrder.isAllowToConfirm &&
      this.getStoreStatus()?.isDisplay &&
      this.checkIfTimeInFutureSelected()
    ) {
      const { orderSetup = {} } = this.props;
      const { useRadiusBasedDeliveryAreaCalulation = false } = orderSetup;
      if (
        (useRadiusBasedDeliveryAreaCalulation ? true : currentOrder.suburbId) &&
        currentOrder.orderType === '2'
      ) {
        if (
          !currentOrder.deliveryDate ||
          !currentOrder.shiftId ||
          currentOrder.shiftId.length <= 0
        ) {
          let timeObj =
            this.state.deliveryTimes && this.state.deliveryTimes[0].times[0];
          let deliveryDate = moment(
            `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
            'YYYY-MM-DD HH:mm A'
          );
          this.props.updateDeliveryPickupTime(
            deliveryDate,
            timeObj.shiftId,
            true,
            stage,
            timeObj.alternateDisplay === 'ASAP' ? false : true
          );
        }
        // Pickup
      } else if (
        currentOrder.orderType === '1' &&
        this.state.pickUpTimes.length
      ) {
        if (
          !currentOrder.deliveryDate ||
          !currentOrder.shiftId ||
          currentOrder.shiftId.length <= 0
        ) {
          let [
            {
              times: [
                { shiftId, alternateDisplay, timeObjFinal, displayForUse },
              ],
            },
          ] = this.state.pickUpTimes;
          const date = `${timeObjFinal} ${displayForUse}`;
          this.props.updateDeliveryPickupTime(
            m(date),
            shiftId,
            true,
            stage,
            alternateDisplay === 'ASAP' ? false : true
          );
        }
        // Dine-in
      } else if (
        currentOrder.orderType === '3' &&
        this.checkIfTableSelected()
      ) {
        if (!currentOrder.deliveryDate) {
          const deliveryDate = moment();

          this.props.updateDeliveryPickupTime(
            deliveryDate,
            false,
            true,
            stage,
            true
          );
        }
      }
      this.props.updateOrderStage(stage);
    } else if (currentOrder.orderType === '2' && currentOrder.address === '') {
      // order address error
      this.setState({ deliveryAddressMissing: true });
      setTimeout(() => {
        this.setState({ deliveryAddressMissing: false });
      }, 3000);
    } else if (currentOrder.orderType === '3' && !currentOrder.tableId) {
      // order table error
      this.setState({ showErrorInTableSelector: true });
      setTimeout(() => {
        this.setState({ showErrorInTableSelector: false });
      }, 3000);
    }
  };

  stage1Check = (stage) => {
    try {
      if (
        (this.props?.currentUser?.phoneNumber ||
          this.props?.userDetails?.mobileNumber) &&
        stage !== 0
      ) {
        this.props.history.push('/review-order');
      } else if (stage !== 0) {
        this.props.history.push('/username');
      }
    } catch (err) {
      console.log(err);
    }
  };

  switchSections(e, type) {
    e.preventDefault();
    if (this.props.currentOrder.orderType !== type) {
      this.props.updateOrderType(type);
      this.toggleErrorStateForFutureTimeSelection(false);
    }
  }

  getDeliveryDateFormatted = (deliveryDate) => {
    const { storeConfig } = this.props;
    if (moment(deliveryDate).tz(storeConfig.timeZone).isSame(moment(), 'day')) {
      return `Today ${moment(deliveryDate)
        .tz(storeConfig.timeZone)
        .format('hh:mm a')}`;
    } else if (
      moment(deliveryDate)
        .tz(storeConfig.timeZone)
        .isSame(moment().tz(storeConfig.timeZone).add(1, 'day'), 'day')
    ) {
      return `Tomorrow ${moment(deliveryDate)
        .tz(storeConfig.timeZone)
        .format('hh:mm a')}`;
    } else {
      return `${moment(deliveryDate)
        .tz(storeConfig.timeZone)
        .format('Do MMM hh:mm a')}`;
    }
  };

  sliderGo = (e, n) => {
    this.setState({
      widthS: e.currentTarget.offsetWidth,
      leftS: e.currentTarget.offsetLeft,
      active: n,
    });
    if (this.swiper) {
      this.swiper.slideTo(n);
    }
  };

  openTimeBar = (e) => {
    let timeG = '';
    let deliveryDateLater = '';
    let isFutureDeliveryDate = false;
    let shiftIdLater = '';
    if (this.state.pickUpTimes.length !== 0) {
      if (this.props.currentOrder.orderType === '1') {
        timeG =
          this.state.pickUpTimes[this.state.active].times[0].displayForUse;
        deliveryDateLater = moment(
          `${this.state.pickUpTimes[this.state.active].times[0].timeObjFinal} ${
            this.state.pickUpTimes[this.state.active].times[0].displayForUse
          }`,
          'YYYY-MM-DD HH:mm A'
        );
        isFutureDeliveryDate =
          this.state.pickUpTimes[this.state.active].times[0]
            .alternateDisplay === 'ASAP'
            ? false
            : true;
        shiftIdLater =
          this.state.pickUpTimes[this.state.active].times[0].shiftId;
      } else {
        timeG =
          this.state.deliveryTimes[this.state.active].times[0].displayForUse;
        deliveryDateLater = moment(
          `${
            this.state.deliveryTimes[this.state.active].times[0].timeObjFinal
          } ${
            this.state.deliveryTimes[this.state.active].times[0].displayForUse
          }`,
          'YYYY-MM-DD HH:mm A'
        );
        isFutureDeliveryDate =
          this.state.deliveryTimes[this.state.active].times[0]
            .alternateDisplay === 'ASAP'
            ? false
            : true;
        shiftIdLater =
          this.state.deliveryTimes[this.state.active].times[0].shiftId;
      }
    }

    if (this.state.active !== 0) {
      this.setState({
        widthS: this.refs[this.state.active + 'LA'].offsetWidth,
        timeSlot: true,
        selectedTime: timeG,
        deliveryDateLater,
        isFutureDeliveryDate,
        shiftIdLater,
      });
    } else if (this.refs[0 + 'LA'] !== undefined) {
      this.setState({
        widthS: this.refs[0 + 'LA'].offsetWidth,
        timeSlot: true,
        selectedTime: timeG,
        deliveryDateLater,
        isFutureDeliveryDate,
        shiftIdLater,
      });
    }
    e.stopPropagation();
  };

  handleOutSideTime = (e) => {
    const aNode = findDOMNode(this.refs.timeSlot);
    if (aNode && aNode.classList.contains('active')) {
      if (!aNode || !aNode.contains(e.target)) {
        this.setState({ timeSlot: false });
      }
    }
    const aNode1 = findDOMNode(this.refs.card);
    if (!aNode1 || !aNode1.contains(e.target)) {
      this.setState({ moveNextDetail: 0 });
    }
  };

  getStoreStatus = () => {
    const { order, storeConfig, orderSetup, currentOrder, closeDates } =
      this.props;
    const now = moment().tz(storeConfig.timeZone);

    const currentShifts = order.allShifts.filter((s) => {
      return s.day === now.format(`E`);
    });

    if (order.allShifts.length === 0 || !orderSetup) {
      return {
        isDisplay: false,
        text: `Loading...`,
      };
    }

    if (!currentShifts.length) {
      return {
        isDisplay: false,
        text: 'Store Closed',
      };
    } else {
      const seconds = now.second() + now.minute() * 60 + now.hour() * 60 * 60;
      let currentShift = currentShifts[0];

      if (currentShifts.length > 1) {
        const fittingShift = currentShifts.find(
          (s) => s.openingStart <= seconds && s.openingEnd >= seconds
        );
        if (fittingShift) {
          currentShift = fittingShift;
        }
      }

      const {
        noPickup,
        noDelivery,
        noDineIn,
        pickup24,
        delivery24,
        deliveryStart,
        deliveryEnd,
        openingStart: pickupStart,
        openingEnd: pickupEnd,
      } = currentShift;

      const closed = closeDates.find(
        (d) => d.closeDate === now.format(`YYYY-MM-DD`)
      );

      const deliveryPossible =
        !noDelivery &&
        ((seconds < deliveryEnd && seconds > deliveryStart) || delivery24) &&
        (!closed || !(closed.isAllClosed || closed.isDeliveryClosed));
      const pickupPossible =
        !noPickup &&
        ((seconds < pickupEnd && seconds > pickupStart) || pickup24) &&
        (!closed || !closed.isAllClosed);

      if (currentOrder.orderType === `3`) {
        if (noDineIn) {
          return {
            isDisplay: false,
            text: `Dine-in Closed`,
          };
        } else {
          return {
            isDisplay: true,
            text: `Order Dine-in`,
          };
        }
      }

      const minOrderPrice =
        this.getMinOrderPrice() !== 0 ? this.getMinOrderPrice() : '';

      if (!deliveryPossible || !pickupPossible) {
        if (!orderSetup.isPreOrderingEnabled) {
          if (!pickupPossible && !deliveryPossible) {
            return {
              isDisplay: false,
              text: `Store Closed`,
            };
          }
          if (deliveryPossible && currentOrder.orderType === `1`) {
            return {
              isDisplay: false,
              text: `Pickup Closed`,
            };
          }
          if (deliveryPossible && currentOrder.orderType === `2`) {
            return {
              isDisplay: true,
              text: `Order Delivery ${minOrderPrice}`,
            };
          }
          if (pickupPossible && currentOrder.orderType === `2`) {
            return {
              isDisplay: false,
              text: `Delivery Closed`,
            };
          }
          if (pickupPossible && currentOrder.orderType === `1`) {
            return {
              isDisplay: true,
              text: `Order Pickup ${minOrderPrice}`,
            };
          }
        } else {
          if (
            !pickupPossible &&
            currentOrder.orderType === `1` &&
            this.state.pickUpTimes?.length
          ) {
            return {
              isDisplay: true,
              text: `Pre-Order Pickup ${minOrderPrice}`,
            };
          }
          if (
            !deliveryPossible &&
            currentOrder.orderType === `2` &&
            this.state.deliveryTimes?.length
          ) {
            return {
              isDisplay: true,
              text: `Pre-Order Delivery ${minOrderPrice}`,
            };
          }
          if (
            !this.state.pickUpTimes?.length &&
            !this.state.deliveryTimes?.length
          ) {
            return {
              isDisplay: `false`,
              text: `Store Closed`,
            };
          }
          return {
            isDisplay: true,
            text: `Order ${
              orderLabels[currentOrder.orderType]
            } ${minOrderPrice}`,
          };
        }
      } else {
        return {
          isDisplay: true,
          text: `Order ${orderLabels[currentOrder.orderType]} ${minOrderPrice}`,
        };
      }
    }
  };

  getMinOrderPrice = () => {
    const { storeConfig, currentOrder, orderSetup = {}, order } = this.props;
    const { useRadiusBasedDeliveryAreaCalulation = false } = orderSetup;
    if (useRadiusBasedDeliveryAreaCalulation && !currentOrder?.areaCode)
      return 0;
    let resTring = 0;
    const totalCostForDelivery = (
      Number(currentOrder.payableAmount) -
      Number(currentOrder.deliveryCost ? currentOrder.deliveryCost : 0)
    ).toFixed(2);

    const suburb = order?.allSuburbs?.find((s) => {
      return s._id === currentOrder.suburbId;
    });

    const minDeliveryValue = orderSetup?.useRadiusBasedDeliveryAreaCalulation
      ? Number(currentOrder.minOrderValue)
      : Number(suburb?.minOrderValue) ||
        Number(orderSetup?.minDeliveryOrderValue);
    if (
      currentOrder &&
      currentOrder.orderType === '1' &&
      orderSetup &&
      orderSetup.minPickupOrderValue &&
      Number(currentOrder.payableAmount) <
        Number(orderSetup.minPickupOrderValue)
    ) {
      resTring = ` - Min. ${storeConfig.currency}${Number(
        orderSetup.minPickupOrderValue
      )}`;
    } else if (
      currentOrder &&
      currentOrder.orderType === '2' &&
      orderSetup &&
      orderSetup.minDeliveryOrderValue &&
      totalCostForDelivery < minDeliveryValue
    ) {
      resTring = ` - Min. ${storeConfig.currency}${(
        Number(minDeliveryValue) + Number(currentOrder.deliveryCost)
      ).toFixed(2)}`;
    }
    return resTring;
  };

  getNextFutureTimeDelivery = () => {
    if (this.state.deliveryTimes && this.state.deliveryTimes.length > 0) {
      let timeObj = this.state.deliveryTimes[0].times[0];
      let deliveryDate = moment(
        `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      return deliveryDate;
    }
  };

  getNextFutureTimePickup = () => {
    if (this.state.pickUpTimes && this.state.pickUpTimes.length > 0) {
      let timeObj = this.state.pickUpTimes[0].times[0];
      let deliveryDate = moment(
        `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      return deliveryDate;
    }
  };

  getTimeToDisplayDayPick = () => {
    const { storeConfig } = this.props;
    if (this.state.pickUpTimes && this.state.pickUpTimes.length > 0) {
      let today = moment(
        moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm a'),
        'YYYY-MM-DD hh:mm A'
      );
      if (
        this.props.currentOrder &&
        this.props.currentOrder.deliveryDate &&
        this.props.currentOrder.isFutureDeliveryDate
      ) {
        let delDate = moment(
          this.props.currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm a'
        );
        if (delDate.isSame(today, 'day')) {
          return ``;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tmr, `;
        } else
          return (
            moment(
              this.props.currentOrder.deliveryDate,
              'YYYY-MM-DD HH:mm A'
            ).format('ddd') + ', '
          );
      } else if (this.props.currentSh) {
        return 'Pickup';
      } else {
        let delDate = this.getNextFutureTimePickup();
        if (delDate.isSame(today, 'day')) {
          return ``;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tmr, `;
        } else
          return (
            moment(
              this.props.currentOrder.deliveryDate,
              'YYYY-MM-DD HH:mm A'
            ).format('ddd') + ', '
          );
      }
    } else {
      return 'Pickup';
    }
  };

  getTimeToDisplayTimePick = () => {
    if (this.state.pickUpTimes && this.state.pickUpTimes.length > 0) {
      if (
        this.props.currentOrder &&
        this.props.currentOrder.deliveryDate &&
        this.props.currentOrder.isFutureDeliveryDate
      ) {
        return moment(
          this.props.currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm A'
        ).format('hh:mm a');
      } else if (
        this.state.currentShift &&
        this.state.currentShift.isPickupOpen &&
        this.props.orderSetup
      ) {
        return `${this.props.orderSetup.pickUpTime} mins`;
      } else {
        let delDate = this.getNextFutureTimePickup();
        return delDate.format('hh:mm a');
      }
    } else {
      return ' N/A';
    }
  };

  getTimeToDisplayDayDel = () => {
    const { storeConfig } = this.props;
    let today = moment(
      moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm A'),
      'YYYY-MM-DD hh:mm A'
    );
    if (this.state.deliveryTimes && this.state.deliveryTimes.length > 0) {
      if (
        this.props.currentOrder &&
        this.props.currentOrder.deliveryDate &&
        this.props.currentOrder.isFutureDeliveryDate
      ) {
        let delDate = moment(
          this.props.currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm A'
        );
        if (delDate.isSame(today, 'day')) {
          return ``;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tmr, `;
        } else return delDate.format('ddd') + ', ';
      } else if (
        this.state.currentShift &&
        this.state.currentShift.isDeliveryOpen
      ) {
        return '';
      } else {
        let delDate = moment(this.getNextFutureTimeDelivery());
        if (delDate.isSame(moment(), 'day')) {
          return ``;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tmr, `;
        } else return delDate.format('ddd') + ', ';
      }
    } else {
      return 'Delivery ';
    }
  };

  getTimeToDisplayTimeDel = () => {
    if (this.state.deliveryTimes && this.state.deliveryTimes.length > 0) {
      if (
        this.props.currentOrder &&
        this.props.currentOrder.deliveryDate &&
        this.props.currentOrder.isFutureDeliveryDate
      ) {
        return moment(
          this.props.currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm A'
        ).format('hh:mm a');
      } else if (
        this.state.currentShift &&
        this.state.currentShift.isDeliveryOpen &&
        this.props.orderSetup
      ) {
        return `${this.props.orderSetup.deliveryTime} mins`;
      } else {
        let delDate = this.getNextFutureTimeDelivery();
        return delDate.format('hh:mm a');
      }
    } else {
      return 'N/A';
    }
  };

  slideChange = () => {
    let timeValue =
      this.state.pickUpTimes[this.swiper.activeIndex].times[0].displayForUse;
    let timeObj = [];
    if (this.props.currentOrder.orderType === '1') {
      timeObj = this.state.pickUpTimes[this.swiper.activeIndex].times.filter(
        (r) => {
          return r.displayForUse === timeValue;
        }
      );
    } else if (this.props.currentOrder.orderType === '2') {
      timeObj = this.state.deliveryTimes[this.swiper.activeIndex].times.filter(
        (r) => {
          return r.displayForUse === timeValue;
        }
      );
    }
    if (timeObj.length > 0) {
      let deliveryDate = moment(
        `${timeObj[0].timeObjFinal} ${timeObj[0].displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      let isFutureDeliveryDate =
        timeObj[0].alternateDisplay === 'ASAP' ? false : true;
      let shiftIdLater = timeObj.length > 0 ? timeObj[0].shiftId : '';
      this.setState({
        selectedTime: timeValue,
        deliveryDateLater: deliveryDate,
        isFutureDeliveryDate,
        shiftIdLater,
      });
    }
    if (
      this.refs[this.swiper.activeIndex + 'LA'].offsetLeft +
        this.refs[this.swiper.activeIndex + 'LA'].offsetWidth >
      window.innerWidth
    ) {
      this.swiper1.setTranslate(
        window.innerWidth -
          (this.refs[this.swiper.activeIndex + 'LA'].offsetLeft +
            this.refs[this.swiper.activeIndex + 'LA'].offsetWidth) -
          15
      );
    } else {
      this.swiper1.setTranslate(0);
    }
    this.setState({
      active: this.swiper.activeIndex,
      widthS: this.refs[this.swiper.activeIndex + 'LA'].offsetWidth,
      leftS: this.refs[this.swiper.activeIndex + 'LA'].offsetLeft,
    });
  };

  getOptions = (times, index) => {
    let defineOptions =
      times.length > 0 &&
      times.map((time, index1) =>
        time.alternateDisplay === 'ASAP' && index === 0 && index1 === 0 ? (
          <option value={index1} key={index1}>
            {time.displayForUse}
          </option>
        ) : (
          <option value={index1} key={index1}>
            {time.displayForUse}
          </option>
        )
      );
    return defineOptions;
  };

  toggleErrorStateForFutureTimeSelection = (flag) => {
    this.setState({
      showErrorInTimeSelector: flag,
    });
  };

  toggleErrorStateForTableSelection = (flag) => {
    this.setState({
      showErrorInTableSelector: flag,
    });
  };

  render() {
    const {
      storeConfig,
      currentOrder,
      menuItems,
      menuItemSchedules,
      currentUser,
      userDetails,
      orderSetup,
      creditCards,
      itemSizes,
      pathwayToOffers,
      menuItemSizes,
      menuItemSubModifiers,
      soldOutMenuItems,
      mobileCart,
      offers,
    } = this.props;

    const isSoldOutPresent = detectSoldOutItemsInCart(
      currentOrder,
      menuItems,
      soldOutMenuItems
    );

    const isOutOfSchedulePresent = detectOutOfScheduleItemsInCart(
      currentOrder,
      menuItemSchedules
    );

    return (
      <div
        id='main-order-container'
        style={{ transform: this.state.translateLeft }}
        className={
          currentOrder && currentOrder.stage && currentOrder.stage >= 5
            ? 'col-md-4 customBar tempClass hideIt'
            : this.props.rightSideViewVisibilityIndex >= 1
            ? 'col-md-4 customBar tempClass ordercartActive'
            : 'col-md-4 customBar tempClass'
        }
        data-sticky='data-sticky'
      >
        <div className='innerSticky'>
          <div className='Sticky' id='sticky'>
            <div
              className={
                mobileCart && currentOrder && currentOrder.stage < 4
                  ? 'stWrap active'
                  : 'stWrap'
              }
            >
              {window.innerWidth < 1025 && (
                <div
                  className='visible-xs visible-sm close-x thickcon-X'
                  onClick={() => {
                    this.props.toggleMobileCart();
                    this.props.history.replace('/');
                  }}
                />
              )}
              <div>
                <div className='stickyTitle'>Order</div>
                <ul className='fright'>
                  {currentOrder.orderType !== '3' ? (
                    <>
                      {orderSetup && orderSetup.isPickupOn && (
                        <li
                          className={
                            currentOrder && currentOrder.orderType === '1'
                              ? 'active'
                              : ''
                          }
                        >
                          <button
                            className='fright__item'
                            ref='pick1'
                            onClick={(e) => this.switchSections(e, '1')}
                          >
                            <span className='icon-Store2 sideicon' />
                            Pickup
                          </button>
                        </li>
                      )}
                      {orderSetup && orderSetup.isDeliveryOn && (
                        <li
                          className={
                            currentOrder && currentOrder.orderType === '2'
                              ? 'active'
                              : ''
                          }
                        >
                          <button
                            className='fright__item'
                            ref='del1'
                            onClick={(e) => this.switchSections(e, '2')}
                          >
                            <span className='icon-Scooter2 sideicon' />
                            Delivery
                          </button>
                        </li>
                      )}
                    </>
                  ) : (
                    orderSetup &&
                    orderSetup.isDineInOn && (
                      <li className='active'>
                        <button
                          className='fright__item svgicon-container'
                          ref='tabl1'
                          onClick={(e) => this.switchSections(e, '3')}
                        >
                          <span className='sideicon svgicon'>
                            <IconTable />
                          </span>
                          <span>Table</span>
                        </button>
                      </li>
                    )
                  )}
                  {orderSetup && (
                    <span
                      className='swipeBar'
                      style={{ width: this.state.width, left: this.state.left }}
                    />
                  )}
                </ul>
              </div>
              <div
                className={
                  currentOrder.specials && currentOrder.specials.length > 0
                    ? currentOrder.voucherId
                      ? 'fixHeightIssue delcost voucher'
                      : 'fixHeightIssue delcost'
                    : currentOrder.voucherId
                    ? 'fixHeightIssue voucher'
                    : 'fixHeightIssue'
                }
              >
                {currentOrder.stage <= 4 &&
                  currentOrder.orderType &&
                  orderSetup &&
                  ((currentOrder.orderType !== '3' &&
                    (orderSetup.isPickupOn || orderSetup.isDeliveryOn)) ||
                    (currentOrder.orderType === '3' &&
                      orderSetup?.isDineInOn)) && (
                    <OrderPreView
                      currentOrder={currentOrder}
                      incrementItemQuantity={this.props.incrementItemQuantity}
                      decrementItemQuantity={this.props.decrementItemQuantity}
                      incrementExtraQuantity={this.props.incrementExtraQuantity}
                      decrementExtraQuantity={this.props.decrementExtraQuantity}
                      updateOrderDeliveryAddress={
                        this.props.updateOrderDeliveryAddress
                      }
                      allSuburbs={this.props.order.allSuburbs}
                      orderSetup={this.props.orderSetup}
                      updateDeliveryPickupTime={
                        this.props.updateDeliveryPickupTime
                      }
                      deliveryTimes={this.state.deliveryTimes}
                      pickUpTimes={this.state.pickUpTimes}
                      halfHalfSetup={this.props.halfHalfSetup}
                      ref={(instance) => {
                        this._orderPreview = instance;
                      }}
                      currentUser={currentUser}
                      isPickupOpen={
                        this.state.currentShift
                          ? this.state.currentShift.isPickupOpen
                          : false
                      }
                      isDeliveryOpen={
                        this.state.currentShift
                          ? this.state.currentShift.isDeliveryOpen
                          : false
                      }
                      userDetails={userDetails}
                      storeObj={storeConfig}
                      deliveryAddressMissing={this.state.deliveryAddressMissing}
                      showErrorInTimeSelector={
                        this.state.showErrorInTimeSelector
                      }
                      showErrorInTableSelector={
                        this.state.showErrorInTableSelector
                      }
                      toggleErrorStateForFutureTimeSelection={
                        this.toggleErrorStateForFutureTimeSelection
                      }
                      toggleErrorStateForTableSelection={
                        this.toggleErrorStateForTableSelection
                      }
                      menuItemSizes={menuItemSizes}
                      menuItemSubModifiers={menuItemSubModifiers}
                      dineInObjects={this.props.dineInObjects}
                      floors={this.props.floors}
                      addTableToOrder={this.props.addTableToOrder}
                      getItemPrice={this.props.getItemPrice}
                    />
                  )}
              </div>

              <div
                className={
                  (currentOrder.specialDiscount &&
                    Number(currentOrder.specialDiscount) <= 0) ||
                  isSoldOutPresent ||
                  isOutOfSchedulePresent
                    ? 'visible-xs visible-sm discountBar hideSpec'
                    : 'visible-xs visible-sm discountBar'
                }
              >
                {currentOrder?.rewards?.length > 0 && (
                  <div className='specialDisc equal'>
                    Loyalty
                    <span>{`-${storeConfig.currency}${currentOrder.loyaltyDiscount}`}</span>
                  </div>
                )}
                <div
                  className={
                    currentOrder.orderType === '1'
                      ? this.getTimeToDisplayDayPick() === `` ||
                        this.getTimeToDisplayDayPick() === `Pickup`
                        ? 'specialDisc equal'
                        : 'specialDisc'
                      : this.getTimeToDisplayDayDel() === `` ||
                        this.getTimeToDisplayDayDel() === `Delivery`
                      ? 'specialDisc equal'
                      : 'specialDisc'
                  }
                >
                  Specials
                  <span>{`-${storeConfig.currency}${currentOrder.specialDiscount}`}</span>
                </div>
                {!isSoldOutPresent &&
                  !isOutOfSchedulePresent &&
                  currentOrder.orderType !== '3' && (
                    <div
                      className='timeDisc'
                      onClick={(e) => this.openTimeBar(e)}
                    >
                      <i
                        className={
                          this.state.showErrorInTimeSelector
                            ? 'icon-Clock error'
                            : 'icon-Clock'
                        }
                      />
                      <div
                        style={{ display: 'inline-block' }}
                        className={
                          this.state.showErrorInTimeSelector
                            ? 'time-info error'
                            : 'time-info'
                        }
                      >
                        {currentOrder.orderType === '1'
                          ? `${
                              this.props.orderSetup &&
                              this.state.currentShift &&
                              this.props.orderSetup.isPreOrderingEnabled ===
                                true &&
                              this.state.currentShift.isPickupOpen === false &&
                              (!currentOrder.deliveryDate ||
                                !currentOrder.shiftId ||
                                currentOrder.shiftId.length <= 0)
                                ? `Select Time`
                                : `${this.getTimeToDisplayDayPick()}${this.getTimeToDisplayTimePick()}`
                            }`
                          : `${
                              this.props.orderSetup &&
                              this.state.currentShift &&
                              this.props.orderSetup.isPreOrderingEnabled ===
                                true &&
                              this.state.currentShift.isDeliveryOpen ===
                                false &&
                              (!currentOrder.deliveryDate ||
                                !currentOrder.shiftId ||
                                currentOrder.shiftId.length <= 0)
                                ? `Select Time`
                                : `${this.getTimeToDisplayDayDel()}${this.getTimeToDisplayTimeDel()}`
                            }`}
                      </div>
                      <span
                        className={
                          this.state.showErrorInTimeSelector ? 'error' : ''
                        }
                      >
                        Change
                      </span>
                    </div>
                  )}
              </div>

              {window.innerWidth < 1024 && (
                <React.Fragment>
                  {currentOrder.orderType === '2' ? (
                    <div
                      ref='timeSlot'
                      className={
                        this.state.timeSlot
                          ? 'visible-xs visible-sm timeSlots active'
                          : 'visible-xs visible-sm timeSlots'
                      }
                    >
                      <div className='swiperWeek'>
                        <Swiper
                          {...this.params}
                          ref={(node) => {
                            if (node) this.swiper1 = node.swiper;
                          }}
                        >
                          {this.state.deliveryTimes &&
                            this.state.deliveryTimes.map((d, index) => (
                              <div
                                ref={(c) => {
                                  this.refs[index + 'LA'] = c;
                                }}
                                key={index}
                                onClick={(e) => this.sliderGo(e, Number(index))}
                                className={
                                  this.state.active === Number(index)
                                    ? 'active tabSUL'
                                    : 'tabSUL'
                                }
                              >
                                {d.display}
                              </div>
                            ))}
                          <span
                            className='slidebarExtras'
                            style={{
                              width: this.state.widthS,
                              left: this.state.leftS,
                            }}
                          />
                        </Swiper>
                      </div>
                      <div className='swiperTime'>
                        <Swiper
                          {...this.params2}
                          ref={(node) => {
                            if (node) this.swiper = node.swiper;
                          }}
                        >
                          {this.state.deliveryTimes &&
                            this.state.deliveryTimes.map((item, index) => (
                              <div className='subTimeXS' key={index}>
                                <Select
                                  handleChange={this.handleChange}
                                  key={`picker${index}`}
                                  data={item}
                                  index={index}
                                />
                              </div>
                            ))}
                        </Swiper>
                      </div>
                      <div
                        className='selectTime'
                        onClick={(e) => this.setDeliveryTime(e)}
                      >
                        Set Delivery Time
                        <span>
                          {this.state.selectedTime !== ''
                            ? this.refs[this.state.active + 'LA'] &&
                              this.refs[this.state.active + 'LA']
                                .textContent !== 'Today'
                              ? ` - ${
                                  this.refs[this.state.active + 'LA']
                                    .textContent
                                }, ${this.state.selectedTime}`
                              : ` - ${this.state.selectedTime}`
                            : ''}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div
                      ref='timeSlot'
                      className={
                        this.state.timeSlot
                          ? 'visible-xs visible-sm timeSlots active'
                          : 'visible-xs visible-sm timeSlots'
                      }
                    >
                      <div className='swiperWeek'>
                        <Swiper
                          {...this.params}
                          ref={(node) => {
                            if (node) this.swiper1 = node.swiper;
                          }}
                        >
                          {this.state.pickUpTimes &&
                            this.state.pickUpTimes.map((d, index) => (
                              <div
                                ref={index + 'LA'}
                                key={index}
                                onClick={(e) => this.sliderGo(e, Number(index))}
                                className={
                                  this.state.active === Number(index)
                                    ? 'active tabSUL'
                                    : 'tabSUL'
                                }
                              >
                                {d.display}
                              </div>
                            ))}
                          <span
                            className='slidebarExtras'
                            style={{
                              width: this.state.widthS,
                              left: this.state.leftS,
                            }}
                          />
                        </Swiper>
                      </div>
                      <div className='swiperTime'>
                        <Swiper
                          {...this.params2}
                          ref={(node) => {
                            if (node) this.swiper = node.swiper;
                          }}
                        >
                          {this.state.pickUpTimes &&
                            this.state.pickUpTimes.map((item, index) => (
                              <div className='subTimeXS' key={index}>
                                <Select
                                  handleChange={this.handleChange}
                                  key={`picker${index}`}
                                  data={item}
                                  index={index}
                                />
                              </div>
                            ))}
                        </Swiper>
                      </div>
                      <div
                        className='selectTime'
                        onClick={(e) => this.setDeliveryTime(e)}
                      >
                        Set Pickup Time
                        <span>
                          {this.state.selectedTime !== ''
                            ? this.refs[this.state.active + 'LA'] &&
                              this.refs[this.state.active + 'LA']
                                .textContent !== 'Today'
                              ? ` - ${
                                  this.refs[this.state.active + 'LA']
                                    .textContent
                                }, ${this.state.selectedTime}`
                              : ` - ${this.state.selectedTime}`
                            : ''}
                        </span>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}

              {window.innerWidth < 1024 && (
                <div
                  className={
                    this.state.timeSlot
                      ? 'overlayTime visible-xs visible-sm active'
                      : 'overlayTime visible-xs visible-sm'
                  }
                />
              )}

              <div className='totalbottom'>
                <div className='totalInner'>
                  {isOutOfSchedulePresent && (
                    <div
                      className='soldOutTxt spWrap'
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '14px',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        Sorry, some menu items are not available for the
                        selected order time.
                      </div>
                      <div
                        className='soldoutOk'
                        onClick={() => this.props.removeOutOfScheduleItems()}
                      >
                        <div className='soldoutOkContent'>Modify Cart</div>
                      </div>
                    </div>
                  )}
                  {isSoldOutPresent && (
                    <div
                      className='soldOutTxt spWrap'
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '14px',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        Sorry, some items have been marked as sold out.
                      </div>
                      <div
                        className='soldoutOk'
                        onClick={() => this.props.removeSoldOutItems()}
                      >
                        <div className='soldoutOkContent'>Modify Cart</div>
                      </div>
                    </div>
                  )}

                  {currentOrder.isFreeItemsAvailable && (
                    <div
                      className='soldOutTxt spWrap'
                      style={{
                        justifyContent: 'space-between',
                        marginBottom: '14px',
                      }}
                    >
                      <div style={{ marginRight: '10px' }}>
                        {getOfferUnlockedMessage(storeConfig, currentOrder)}
                      </div>
                    </div>
                  )}
                  {currentOrder.publicHolidaySurcharge &&
                  Number(currentOrder.publicHolidaySurcharge) !== 0 ? (
                    <div className='spWrap'>
                      <span className='spName'>
                        Public Holiday Surcharge
                        {`${
                          currentOrder &&
                          currentOrder.publicHolidaySurchargePer &&
                          Number(currentOrder.publicHolidaySurchargePer) !== 0
                            ? `(${currentOrder.publicHolidaySurchargePer}%)`
                            : null
                        }`}
                      </span>
                      <span className='spPrice'>{`${storeConfig.currency}${currentOrder.publicHolidaySurcharge}`}</span>
                    </div>
                  ) : (
                    <div />
                  )}

                  {currentOrder.rewards && currentOrder.rewards.length > 0 ? (
                    <div className='spWrap'>
                      <span className='spName'>Loyalty</span>
                      <span className='spPrice'>{`- ${storeConfig.currency}${currentOrder.loyaltyDiscount}`}</span>
                    </div>
                  ) : (
                    <div />
                  )}

                  {currentOrder.specials &&
                  currentOrder.specials.length > 0 &&
                  Number(currentOrder?.specialDiscount) > 0 ? (
                    <div className='spWrap'>
                      <span className='spName'>Specials</span>
                      <span className='spPrice'>{`- ${storeConfig.currency}${currentOrder.specialDiscount}`}</span>
                    </div>
                  ) : (
                    <div />
                  )}

                  {/* Voucher Section */}
                  {currentOrder.voucherId &&
                  currentOrder.voucherId !== '' &&
                  Number(currentOrder.voucherDiscount) !== 0 ? (
                    <div className='spWrap'>
                      <span className='spName'>Voucher</span>
                      <span className='spPrice'>{`- ${storeConfig.currency}${currentOrder.voucherDiscount} `}</span>
                    </div>
                  ) : (
                    <div />
                  )}

                  {/* GST Section */}
                  {currentOrder.isDisplayGST &&
                  !currentOrder.isPriceIncludesGST &&
                  Number(currentOrder.gst) !== 0 ? (
                    <div className='spWrap'>
                      <span className='spName'>GST</span>
                      <span className='spPrice'>{` ${storeConfig.currency}${currentOrder.gst} `}</span>
                    </div>
                  ) : (
                    <div />
                  )}

                  {/* Total Section*/}
                  <div className='spTotal'>
                    <span className='spName'>Total</span>
                    <span className='spPrice'>
                      {currentOrder && currentOrder.payableAmount
                        ? `${storeConfig.currency}${currentOrder.payableAmount} `
                        : `${storeConfig.currency}0.00`}
                    </span>
                  </div>

                  {/* Button to place order - delivery and pickup */}
                  <div
                    className={
                      currentOrder?.isAllowToConfirm &&
                      this.getStoreStatus()?.isDisplay &&
                      !isSoldOutPresent &&
                      !isOutOfSchedulePresent
                        ? 'confirmBtn'
                        : 'confirmBtn diableConfirm'
                    }
                    onClick={() => this.updateOrderStageHandler(1)}
                  >
                    {this.getStoreStatus()?.text}
                    {this.getStoreStatus()?.isDisplay && (
                      <span className='visible-xs visible-sm'>
                        {this.getMinOrderPrice() === 0
                          ? `${storeConfig.currency}${currentOrder.payableAmount}`
                          : ''}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* don't touch the order of components */}
            {this.props.menuItems &&
              this.props.menuItems.length > 0 &&
              currentOrder.stage < 3 && (
                <HalfOrderView
                  ingredientCategories={this.props.order.ingredientCategories}
                  spMenuSizes={this.props.spMenuSizes}
                  rightSideViewVisibilityIndex={
                    this.props.rightSideViewVisibilityIndex
                  }
                  toggleAnimation={this.props.toggleSpeacialItem}
                  orderItem={this.props.orderItem}
                  itemInProgress={this.props.itemInProgress}
                  openedItemId={this.props.itemInProgress?._id}
                  closeOrder={this.props.hideHalfItem}
                  addToOrder={this.props.addToHalfHalf}
                  history={this.props.history}
                  soldOutMenuItems={this.props.soldOutMenuItems}
                />
              )}

            {this.props.menuItems &&
              this.props.menuItems.length > 0 &&
              currentOrder.stage < 3 && (
                <HalfHalfView
                  toggleAnimation={this.props.halfAnimation}
                  hideOrder={this.props.hideOrder}
                  rightSideViewVisibilityIndex={
                    this.props.rightSideViewVisibilityIndex
                  }
                  halfItem={this.props.halfItem}
                  halfFilter={this.props.halfFilter}
                  selectedHalfItems={this.props.selectedHalfItems}
                  addHalfHalfToOrder={this.props.addHalfHalfToOrder}
                  clearItemsNotAvailableForVariants={
                    this.props.clearItemsNotAvailableForVariants
                  }
                  whichHalf={this.props.whichHalf}
                  menuItems={this.props.menuItems}
                  clearOrChangeSize={this.props.clearOrChangeSize}
                  itemSizes={itemSizes}
                />
              )}

            {this.props.menuItems &&
              this.props.menuItems.length > 0 &&
              currentOrder.stage < 3 && (
                <SpecialOrderView
                  ingredientCategories={this.props.order.ingredientCategories}
                  spMenuSizes={this.props.spMenuSizes}
                  rightSideViewVisibilityIndex={
                    this.props.rightSideViewVisibilityIndex
                  }
                  toggleAnimation={this.props.toggleSpeacialItem}
                  orderItem={this.props.orderItem}
                  itemInProgress={this.props.itemInProgress}
                  openedItemId={this.props.itemInProgress?._id}
                  closeOrder={this.props.hideSpecialItem}
                  addToOrder={this.props.addToSpecial}
                  history={this.props.history}
                  soldOutMenuItems={this.props.soldOutMenuItems}
                />
              )}

            {this.props.menuItems &&
              this.props.menuItems.length > 0 &&
              currentOrder.stage < 3 && (
                <SpecialView
                  showSpecialItem={this.props.showSpecialItem}
                  menuItems={this.props.menuItems}
                  addToSpecial={this.props.addToSpecial}
                  filterView={this.props.filterView}
                  rightSideViewVisibilityIndex={
                    this.props.rightSideViewVisibilityIndex
                  }
                  toggleAnimation={this.props.toggleSpecials}
                  specialItem={this.props.specialItem}
                  hideOrder={this.props.hideOrder}
                  selectedSpecials={this.props.selectedSpecials}
                  addSpecialToOrder={this.props.addSpecialToOrder}
                  itemExist={this.props.itemExist}
                  storeConfig={this.props.storeConfig}
                />
              )}

            {this.props.menuItems && this.props.menuItems.length > 0 && (
              <OrderView
                ingredientCategories={this.props.order.ingredientCategories}
                rightSideViewVisibilityIndex={
                  this.props.rightSideViewVisibilityIndex
                }
                spMenuSizes={this.props.spMenuSizes}
                toggleAnimation={this.props.toggleAnimation}
                orderItem={this.props.orderItem}
                itemInProgress={this.props.itemInProgress}
                openedItemId={this.props.itemInProgress?._id}
                closeOrder={this.props.hideOrder}
                addToOrder={this.props.addToOrder}
                history={this.props.history}
                soldOutMenuItems={this.props.soldOutMenuItems}
              />
            )}
            <TableBoookingView
              rightSideViewVisibilityIndex={
                this.props.rightSideViewVisibilityIndex
              }
              reservation={this.props.reservation}
              history={this.props.history}
              closeReservation={this.props.closeReservation}
              addReservationhandler={this.props.addReservationhandler}
              userDetails={this.props.userDetails}
              updateOrderStage={this.props.updateOrderStage}
              allShifts={this.props.order.allShifts}
              storeObj={storeConfig}
              closeDates={this.props.order.closeDates}
              orderSetup={this.props.orderSetup}
            />
            <AboutDesktop
              userDetails={this.props.userDetails}
              updateOrderStage={this.props.updateOrderStage}
              storeObj={storeConfig}
              openDelivery={this.props.openDelivery}
              allSuburbs={this.props.order.allSuburbs}
              allShifts={this.props.order.allShifts}
              currentShift={this.state.currentShift}
              reviewStats={this.props.layout.reviewStats}
              reviewStatsByRating={this.props.layout.reviewStatsByRating}
              isDeliveryOn={
                orderSetup && orderSetup.isDeliveryOn
                  ? orderSetup.isDeliveryOn
                  : false
              }
            />
            <LoyaltyDesktop
              loyaltyOpen={this.props.loyaltyOpen}
              close={() => this.props.setState({ loyaltyOpen: false })}
              initiateDesktopLoyaltyFlow={this.props.initiateDesktopLoyaltyFlow}
              rightSideViewVisibilityIndex={
                this.props.rightSideViewVisibilityIndex
              }
              history={this.props.history}
              userDetails={this.props.userDetails}
              updateOrderStage={this.props.updateOrderStage}
              store={storeConfig}
              currentUser={this.props.currentUser}
              offers={offers}
              pathwayToOffers={pathwayToOffers}
              storeConfig={this.props.storeConfig}
            />
            {/* dont touch the order */}

            <div
              className={
                currentOrder.stage >= 1 && currentOrder.stage < 5
                  ? 'detailsConfirmWrap active'
                  : 'detailsConfirmWrap'
              }
            >
              {/* Back arrow to travese back */}
              <div
                className={
                  currentOrder.stage >= 3
                    ? `backToOrder detail${this.state.moveNextDetail} thickcon-Left-Chevron active ${this.state.moveUp}`
                    : `backToOrder detail${this.state.moveNextDetail} thickcon-Left-Chevron ${this.state.moveUp}`
                }
                onClick={() => {
                  this.props.updateOrderStageBack();
                }}
              />
              {this.props.menuItems &&
                this.props.userDetails === undefined &&
                currentOrder.stage !== 3 && (
                  <>
                    <UserLoginRegistration
                      currentOrder={currentOrder}
                      userDetails={this.props.userDetails}
                      updateOrderStage={this.props.updateOrderStage}
                      updateCurrentUser={this.props.updateCurrentUser}
                      history={this.props.history}
                      initiateDesktopLoyaltyFlow={
                        this.props.initiateDesktopLoyaltyFlow
                      }
                      loyalty={this.props.loyalty}
                      inLayoutFlow={this.props.inLayoutFlow}
                      orderSetup={this.props.orderSetup}
                      storeConfig={this.props.storeConfig}
                    />
                  </>
                )}

              {/*  Review your order component - user should be logged in*/}
              {currentOrder &&
                currentOrder.isAllowToConfirm &&
                currentOrder.stage <= 4 &&
                currentOrder.stage !== 2 &&
                this.props.rightSideViewVisibilityIndex !== 6 && (
                  <OrderReview
                    currentOrder={currentOrder}
                    menuItems={menuItems}
                    removeSoldOutItems={this.props.removeSoldOutItems}
                    removeOutOfScheduleItems={
                      this.props.removeOutOfScheduleItems
                    }
                    userDetails={userDetails}
                    updateOrderStage={this.props.updateOrderStage}
                    allVouchers={this.props.reviewOrder.allVouchers}
                    updateVoucher={this.props.updateVoucher}
                    history={this.props.history}
                    saveUnit={this.props.saveUnit}
                    halfHalfSetup={this.props.halfHalfSetup}
                    pickUpTimes={this.state.pickUpTimes}
                    deliveryTimes={this.state.deliveryTimes}
                    updateDeliveryPickupTime={
                      this.props.updateDeliveryPickupTime
                    }
                    getDiscountedAmount={this.props.getDiscountedAmount}
                    isSoldOutPresent={isSoldOutPresent}
                    isOutOfSchedulePresent={isOutOfSchedulePresent}
                  />
                )}

              {/* Payment Component*/}
              {currentOrder &&
                currentOrder.isAllowToConfirm &&
                currentOrder.stage >= 3 &&
                currentOrder.stage !== 5 && (
                  <OrderPayment
                    orderSetup={orderSetup}
                    updateOrderStage={this.props.updateOrderStage}
                    updatePaymentTypeForCash={
                      this.props.updatePaymentTypeForCash
                    }
                    updatePaymentTypeForWallet={
                      this.props.updatePaymentTypeForWallet
                    }
                    userDetails={userDetails}
                    fetchOrderHandler={this.props.fetchOrderHandler}
                    pickUpTimes={this.state.pickUpTimes}
                    deliveryTimes={this.state.deliveryTimes}
                    updateDeliveryPickupTime={
                      this.props.updateDeliveryPickupTime
                    }
                    creditCards={creditCards}
                    history={this.props.history}
                  />
                )}
              {/* Payment Cards Component*/}
              {currentOrder &&
                currentOrder.isAllowToConfirm &&
                currentOrder.stage >= 3 &&
                currentOrder.stage !== 5 && (
                  <OrderPaymentCards
                    orderSetup={orderSetup}
                    paymentCards={this.props.reviewOrder.paymentCards}
                    paymentCardsFetched={this.props.reviewOrder.fetched}
                    updateOrderStage={this.props.updateOrderStage}
                    updatePaymenyType={this.props.updatePaymenyType}
                    updatePaymentTypeForNewCard={
                      this.props.updatePaymentTypeForNewCard
                    }
                    updatePaymentTypeForCard={
                      this.props.updatePaymentTypeForCard
                    }
                    fetchOrderHandler={this.props.fetchOrderHandler}
                    history={this.props.history}
                    userDetails={userDetails}
                    pickUpTimes={this.state.pickUpTimes}
                    deliveryTimes={this.state.deliveryTimes}
                    updateDeliveryPickupTime={
                      this.props.updateDeliveryPickupTime
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Order.propTypes = {
  currentOrder: PropTypes.any,
  updateOrderType: PropTypes.any,
  updateOrderDeliveryAddress: PropTypes.any,
  orderSetup: PropTypes.any,
  updateDeliveryPickupTime: PropTypes.any,
  updateOrderStage: PropTypes.any,
  updateOrderStageBack: PropTypes.any,
  updateCurrentUser: PropTypes.any,
  updateVoucher: PropTypes.any,
  updatePaymenyType: PropTypes.any,
  updatePaymentTypeForCash: PropTypes.any,
  updatePaymentTypeForNewCard: PropTypes.any,
  updatePaymentTypeForWallet: PropTypes.any,
  specialItem: PropTypes.any,
  addToSpecial: PropTypes.any,
  rightSideViewVisibilityIndex: PropTypes.any,
  selectedSpecials: PropTypes.any,
  addSpecialToOrder: PropTypes.any,
  selectedHalfItems: PropTypes.any,
  addToHalfHalf: PropTypes.any,
  addHalfHalfToOrder: PropTypes.any,
  clearItemsNotAvailableForVariants: PropTypes.any,
  whichHalf: PropTypes.any,
  menuItems: PropTypes.any,
  clearOrChangeSize: PropTypes.any,
  history: PropTypes.any,
  itemExist: PropTypes.any,
};

function mapStateToProps(state) {
  const {
    homeReducer: {
      creditCards,
      currentUser,
      userDetails,
      orderSetup,
      menuItems,
      pathwayToOffers,
      currentOrder,
      menuItemSizes,
      menuItemSubModifiers,
      itemSizes,
      soldOutMenuItems,
      loyaltyOpen,
      menuItemSchedules,
      ui: { mobileCart },
    },
    orderReducer: { closeDates },
    layoutReducer: { halfHalfSetup, offers },
  } = state;

  return {
    soldOutMenuItems,
    currentOrder,
    currentUser,
    loyaltyOpen,
    userDetails,
    orderSetup,
    menuItems,
    menuItemSchedules,
    creditCards,
    pathwayToOffers,
    closeDates,
    menuItemSizes,
    menuItemSubModifiers,
    itemSizes,
    offers,
    mobileCart,
    halfHalfSetup,
    order: state.orderReducer,
    reviewOrder: state.reviewOrderReducer,
    layout: state.layoutReducer,
    storeConfig: selectStoreConfig(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleMobileCart: () => dispatch(toggleMobileCart()),
    fetchOrderHandler: (orderId) => dispatch(fetchOrder(orderId)),
    setState: (payload) => dispatch(setState(payload)),
    initAction: (storeId, restaurantId) =>
      dispatch(init(storeId, restaurantId)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Order));
